module.exports = __webpack_public_path__ + "img/std-zagreb-v2.e9f0a422.png";